import { api } from "./client";

export async function getCommunityStats(): Promise<{ member_count: number }> {
    return api<{ member_count: number }>("/community/stats", "GET");
}
